export default "__VITE_ASSET__C2aVJ_8l__"